import { useEntityType } from 'hooks';
import { marketingObjectiveValidations } from 'modules/campaigns/config/validations/campaign/marketingObjectiveValidations';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useTrackingState } from 'modules/tracking/hooks/useTrackingState';
import { useFormValidatedValue } from '../../../../../taboola-common-frontend-modules/validations';
import { pixelOrS2sInstalled } from '../../../../../tracking/hooks/pixelOrS2sInstalled';
import { useMarketingObjectiveDependencies } from './useMarketingObjectiveDependencies';
import { usePixelWarningPermitted } from './usePixelWarningPermitted';

export const useMarketingObjectiveWithValidations = ({ savedMarketingObjective, hasCampaigns }) => {
    const isPixelWarningPermitted = usePixelWarningPermitted();
    const isPixelWarningsTesting = useConfigMatch({ [FEATURE_FLAGS.TA_PIXEL_WARNINGS_TESTING]: 'true' });

    const {
        trackingStateData: { pixelTrackingData, s2sTrackingData, hasAtLeastOneActiveConversion },
    } = useTrackingState(isPixelWarningPermitted);
    const isPixelOrS2sInstalled = pixelOrS2sInstalled(pixelTrackingData, s2sTrackingData);

    const entityType = useEntityType();
    const isMandatoryHierarchyEnabled = useConfigMatch({
        [FEATURE_FLAGS.IS_MANDATORY_HIERARCHY_ENABLED]: 'true',
    });
    const dependencies = useMarketingObjectiveDependencies();
    return useFormValidatedValue({
        field: 'marketingObjective',
        validations: marketingObjectiveValidations,
        formFieldDependencies: dependencies,
        validationDependencies: {
            isPixelOrS2sInstalled,
            hasAtLeastOneActiveConversion,
            isPixelWarningsTesting,
            isPixelWarningPermitted,
            ...dependencies,
            entityType,
            savedMarketingObjective,
            isMandatoryHierarchyEnabled,
            hasCampaigns,
        },
    });
};
